<template>
	<div class="flex justify-center items-center" style="height: 100%">
		<AscColorChipRenderer :value="rank_absolute" />
	</div>
</template>

<script>
import AscColorChipRenderer from "./AscColorChipRenderer.vue";
export default {
	props: {
		value: {
			type: Number,
			default: 0,
		},
	},
	components: {
		AscColorChipRenderer,
	},
	data() {
		return {
			rank_absolute: 0,
		};
	},

	created() {
		this.getRankAbsolute(this.params.value);
	},
	methods: {
		getRankAbsolute(val) {
			this.params.data.keywords.forEach((element) => {
				if (element.keyword == this.params.keywordName) {
					this.rank_absolute = element.rank_absolute;
				}
			});
		},
		// Customize gradient color logic
	},
};
</script>

<style scoped>
/* Add styles here if needed */
</style>